<template>
  <div>
    <section id="over-rijnja" class="content-wrapper page">
      <section id="" class="row header">
        <ul class="breadcrumb">
          <li><router-link class="link" to="/">Home</router-link></li>

          <li>
            <inline-svg src="/images/icons/chevron-right-solid.svg"></inline-svg
            >Over Rijnja
          </li>
        </ul>
        <div class="col text">
          <h1>Over Rijnja</h1>
          <p>
            Koninklijke Rijnja levert groot- en kleinformaat printproducten door
            heel Nederland. Maar we doen meer dan dat. Als grootste
            reprografisch dienstverlener van Nederland vinden we het belangrijk
            dat jouw organisatie geen enkel omkijken meer heeft naar het
            printwerk.
          </p>
          <ul>
            <li>Klik & klaar bestelproces op de website</li>
            <li>Persoonlijk contact via één aanspreekpunt</li>
            <li>
              De volgende werkdag door eigen koeriers bezorgd door heel
              Nederland
            </li>
            <li>
              Gecertificeerd in kwaliteits- en milieumanagement
            </li>
          </ul>
        </div>
        <div class="col">
          <printen-en-meer></printen-en-meer>
          <div class="bg-circle g-w"></div>
        </div>
      </section>
      <section class="row reverse">
        <div class="col text">
          <h1>Baanbrekend</h1>
          <p>
            Het is altijd de ambitie van Rijnja geweest om de meest innovatieve
            aanbieder op reprografisch gebied te zijn. Al 130 jaar beschouwen
            wij veranderingen in de markt als een kans die we graag grijpen,
            niet als bedreiging die we moeten bevechten. Daarom werken wij
            altijd met de laatste technologie en introduceren we voortdurend
            nieuwe duurzame printtechnieken en veilige en innovatieve online
            oplossingen.
          </p>
        </div>
        <div class="col image">
          <img class="baanbrekend" src="@/images/pages/baanbrekend.svg" />
        </div>
      </section>

      <section class="row">
        <div class="col-single text">
          <h1>Betrokken</h1>
          <p>
            Rijnja voert uit én denkt mee. Als full service grafisch
            dienstverlener bezorgen we niet alleen printproducten, we staan ook
            klaar om jouw organisatie waar nodig te adviseren. Bij Rijnja kun je
            rekenen op een vast contactpersoon, die ervoor zorgt dat het
            printwerk voor jouw organisatie van A tot Z wordt geregeld. Heb je
            vragen of loop je ergens tegenaan? Dan kun je ons gewoon even bellen
            of komen we bij je langs: Rijnja regelt het.
          </p>
        </div>
      </section>

      <section class="row">
        <div class="col text">
          <h1>Erkende kwaliteit, duurzaamheid en betrouwbaarheid</h1>
          <p>
            Wij vinden het belangrijk dat onze klanten kunnen rekenen op
            printproducten van hoogwaardige kwaliteit, die op een duurzame en
            betrouwbare manier worden geproduceerd. Dit wordt onderschreven door
            onze NEN-ISO 9001:2015 en NEN-ISO 14001:2015 certificaten. Deze
            certificaten tonen aan dat wij voldoen aan de internationaal erkende
            kwaliteitsnormen op het gebied van kwaliteit en
            <router-link class="link-text" to="duurzaam"
              >duurzaamheid</router-link
            >. Ook zijn gecertificeerd volgens de ISO 27001:2022 norm. Hiermee
            waarborgen wij de beveiliging en vertrouwelijkheid van uw bestanden
            en gegevens gedurende het gehele proces.
          </p>
        </div>
        <div class="col image">
          <img
            class="kwaliteit"
            src="@/images/pages/kwaliteit-duurzaamheid-betrouwbaarheid.svg"
          />
        </div>
      </section>

      <section class="row reverse">
        <div class="col text">
          <h1>Marktleider sinds 1892</h1>
          <p>
            In 1892 opent Pieter Liskes Rijnja de eerste lichtdrukkerij van
            Nederland. Drie generaties en ruim 130 jaar later is Rijnja nog
            steeds marktleider binnen Nederland op het gebied van full service
            reprografische dienstverlening. Inmiddels verwerken we met meer dan
            100 medewerkers jaarlijks zo’n 160.000 orders voor meer dan 4.000
            klanten. Dat doen we vanuit vestigingen door heel Nederland.
          </p>
          <p>
            Sinds 2017 mogen we onszelf ‘Koninklijke Rijnja’ noemen, omdat we in
            dat jaar – bij het 125-jarig bestaan - het predicaat Koninklijk
            kregen vanwege de belangrijke en vooraanstaande plaats in ons
            vakgebied en onze bijdrage aan de Nederlandse samenleving en
            cultuur.
          </p>
        </div>
        <div class="col image">
          <img class="sinds1892" src="@/images/pages/rijnja-sinds-1892.svg" />
        </div>
      </section>

      <section class="row" id="contact">
        <div class="col-single">
          <h1>Meer weten?</h1>
          <p>
            Benieuwd naar wat Koninklijke Rijnja voor u kan betekenen? Neem dan
            contact met ons op via onderstaand formulier.
          </p>

          <contact-form
            recipient="verkoop@rijnja.nl"
            class="form"
            subject="Informatieaanvraag Over Rijnja"
            conversion-id="McMQCKuxhJwYEKDetesD"
          ></contact-form>
          <p>
            Wilt u een van onze vestigingen direct bereiken? Bekijk de
            contactgegevens dan op onze
            <router-link class="link-text" to="/contact"
              >contactpagina</router-link
            >.
          </p>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import SiteFooter from '../../components/SiteFooter.vue'
import ContactForm from '../../components/ContactForm.vue'

import PrintenEnMeer from './PrintenEnMeer.vue'
export default {
  components: { SiteFooter, PrintenEnMeer, ContactForm }
}
</script>

<style lang="scss" scoped>
.baanbrekend {
  max-width: 325px;
}

.kwaliteit {
  max-width: 350px;
}

.sinds1892 {
  max-width: 375px;
}

#contact {
  padding-top: 0;
}

.form {
  margin: 20px 0;
}
</style>
